import { CustomerTypeEnum } from "src/_api/models/customer-type-enum";

export const CustomerTypeTranslations = {
  [CustomerTypeEnum.AnnonsKund]: 'Annonskund',
  [CustomerTypeEnum.SkyltKund]: 'Skyltkund'
};
